// Libellés et tons de TOUS les statuts métier : une seule source pour l'ensemble de l'interface.
import { Badge, type Ton } from './ui.tsx';

type Def = Record<string, { libelle: string; ton: Ton }>;

export const STATUTS_INTERVENTION: Def = {
  brouillon: { libelle: 'Brouillon', ton: 'neutre' },
  en_cours: { libelle: 'En cours', ton: 'info' },
  resolue: { libelle: 'Résolue', ton: 'succes' },
  escaladee: { libelle: 'Escaladée', ton: 'ambre' },
  cloturee: { libelle: 'Clôturée', ton: 'neutre' },
};

export const STATUTS_DOSSIER: Def = {
  ouvert: { libelle: 'Ouvert', ton: 'neutre' },
  analyse: { libelle: 'En analyse', ton: 'info' },
  a_valider: { libelle: 'À valider', ton: 'ambre' },
  chiffrage: { libelle: 'Chiffrage', ton: 'info' },
  remis: { libelle: 'Remis', ton: 'succes' },
  clos: { libelle: 'Clos', ton: 'neutre' },
};

export const STATUTS_EXIGENCE: Def = {
  a_qualifier: { libelle: 'À qualifier', ton: 'neutre' },
  inclus_chiffre: { libelle: 'Inclus et chiffré', ton: 'succes' },
  manquant: { libelle: 'Manquant', ton: 'danger' },
  a_clarifier: { libelle: 'À clarifier', ton: 'ambre' },
  autre_lot: { libelle: 'Affecté à un autre lot', ton: 'info' },
  exclu: { libelle: 'Exclu explicitement', ton: 'neutre' },
};

export const STATUTS_DOCUMENT: Def = {
  quarantaine: { libelle: 'En contrôle', ton: 'neutre' },
  en_traitement: { libelle: 'En traitement', ton: 'info' },
  a_valider: { libelle: 'Non validé', ton: 'ambre' },
  valide: { libelle: 'Validé', ton: 'succes' },
  obsolete: { libelle: 'Obsolète', ton: 'ambre' },
  rejete: { libelle: 'Rejeté', ton: 'danger' },
  illisible: { libelle: 'Illisible', ton: 'danger' },
};

export const STATUTS_DEVIS: Def = {
  brouillon: { libelle: 'Brouillon', ton: 'neutre' },
  a_valider: { libelle: 'À valider', ton: 'ambre' },
  validee: { libelle: 'Validé', ton: 'info' },
  emise: { libelle: 'Émis', ton: 'succes' },
  remplacee: { libelle: 'Remplacé', ton: 'neutre' },
  annulee: { libelle: 'Annulé', ton: 'neutre' },
};

/** Chantier (carnet de chantier) : « En préparation » tant qu'il n'est pas lancé ; aucun pourcentage, jamais. */
export const STATUTS_CHANTIER: Def = {
  preparation: { libelle: 'En préparation', ton: 'ambre' },
  lance: { libelle: 'Lancé', ton: 'info' },
  suspendu: { libelle: 'Suspendu', ton: 'ambre' },
  termine: { libelle: 'Terminé', ton: 'succes' },
  clos: { libelle: 'Clos', ton: 'neutre' },
};

export const STATUTS_TACHE: Def = {
  en_file: { libelle: 'En file d’attente', ton: 'neutre' },
  en_cours: { libelle: 'En cours', ton: 'info' },
  termine: { libelle: 'Terminé', ton: 'succes' },
  echec: { libelle: 'Échec', ton: 'danger' },
  annule: { libelle: 'Annulé', ton: 'neutre' },
  annulation_demandee: { libelle: 'Annulation demandée', ton: 'ambre' },
};

function badge(def: Def, statut: string) {
  const s = def[statut] ?? { libelle: statut, ton: 'neutre' as Ton };
  return <Badge ton={s.ton}>{s.libelle}</Badge>;
}

export const BadgeStatutIntervention = ({ statut }: { statut: string }) => badge(STATUTS_INTERVENTION, statut);
export const BadgeStatutDossier = ({ statut }: { statut: string }) => badge(STATUTS_DOSSIER, statut);
export const BadgeStatutExigence = ({ statut }: { statut: string }) => badge(STATUTS_EXIGENCE, statut);
export const BadgeStatutDocument = ({ statut }: { statut: string }) => badge(STATUTS_DOCUMENT, statut);
export const BadgeStatutDevis = ({ statut }: { statut: string }) => badge(STATUTS_DEVIS, statut);
export const BadgeStatutTache = ({ statut }: { statut: string }) => badge(STATUTS_TACHE, statut);
export const BadgeStatutChantier = ({ statut }: { statut: string }) => badge(STATUTS_CHANTIER, statut);

export const DOMAINES_SYSTEME: Record<string, string> = {
  eclairage: 'Éclairage', chauffage: 'Chauffage', climatisation: 'Climatisation', ventilation: 'Ventilation', stores: 'Protections solaires',
  comptage: 'Comptage', supervision: 'Supervision', controle_acces: 'Contrôle d’accès', securite: 'Sécurité', reseau: 'Réseau', autre: 'Autre',
};

export const PROTOCOLES = ['KNX', 'BACnet/IP', 'BACnet MS/TP', 'Modbus TCP', 'Modbus RTU', 'DALI', 'DALI-2', 'M-Bus', 'EnOcean', 'Zigbee', 'Z-Wave',
  'Matter', 'Thread', 'MQTT', 'LON', 'OPC UA', 'SNMP', 'IP (propriétaire)', 'Propriétaire'];
